export default {
  en: {
    actions: {
      event: 'Event',
      news: 'News',
      discussion: 'Discussion',
      engagement: 'Engagement',
      poll: 'Poll',
      organize: 'Organize',
    },
  },
};
